import {getStowCarts, getStowFloors, getStowPackageMetrics} from "../resources/StowResource";
import {CartData, FloorData, Resource, StowPackageMetric} from "../enums";
import {TOTAL} from "../constants";

export const LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN = "LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN";
export const LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE = "LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE";
export const LOAD_STOW_CART_DATA_FOR_CART_LOCATION = "LOAD_STOW_CART_DATA_FOR_CART_LOCATION";
export const LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION = "LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION";
export const LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION = "LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION";


const loadMetricsForCartLocationCallBegin = () => ({
    type: LOAD_METRICS_FOR_CART_LOCATION_CALL_BEGIN
});

const loadMetricsForCartLocationCallFailure = () => ({
    type: LOAD_METRICS_FOR_CART_LOCATION_CALL_FAILURE
});

const loadStowCartDataForCartLocation = (stowCartData) => ({
    type: LOAD_STOW_CART_DATA_FOR_CART_LOCATION,
    stowCartData
})

const loadStowFloorDataForCartLocation = (stowFloorsData) => ({
    type: LOAD_STOW_FLOOR_DATA_FOR_CART_LOCATION,
    stowFloorsData
});

const loadStowPackageMetricsForCartLocation = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_CART_LOCATION,
    stowPackageMetricsMap
});

export const getStowCartDataForCartLocation = (nodeId, cartLocation) => {
    return async (dispatch) => {
        dispatch(loadMetricsForCartLocationCallBegin());
        try {
            const request = constructStowCartDataRequest(nodeId, cartLocation);
            const stowCartData = await getStowCarts(request);
            if (stowCartData) {
                dispatch(loadStowCartDataForCartLocation({floor: cartLocation, cartData: stowCartData[0]}));
            } else {
                dispatch(loadMetricsForCartLocationCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForCartLocationCallFailure());
        }
    }
}

export const getStowFloorDataForCartLocation = (nodeId, zone, fetchRouteData = false) => {
    return async (dispatch) => {
        dispatch(loadMetricsForCartLocationCallBegin());
        try {
            const request = fetchRouteData ? constructStowFloorDataRequestWithRouteDetails(nodeId, zone)
            : constructStowFloorDataRequest(nodeId, zone);

            const stowFloorsDataMap = await getStowFloors(request);
            if (stowFloorsDataMap) {
                dispatch(loadStowFloorDataForCartLocation(stowFloorsDataMap));
            } else {
                dispatch(loadMetricsForCartLocationCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForCartLocationCallFailure());
        }
    }
}

export const getStowPackageMetricsForCartLocation = (nodeId, zone) => {

    return async (dispatch) => {
        dispatch(loadMetricsForCartLocationCallBegin());
        try {
            const request = constructStowPackageMetricsRequest(nodeId, zone);
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                delete stowPackageMetricsMap[TOTAL]
                dispatch(loadStowPackageMetricsForCartLocation(stowPackageMetricsMap));
            } else {
                dispatch(loadMetricsForCartLocationCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForCartLocationCallFailure());
        }
    }
}

const constructStowCartDataRequest = (nodeId, floor) => {
    return {
        filters: {
            NODE: [nodeId],
            FLOOR: [floor]
        },
        fieldsRequired: [
            CartData.CART_LABEL,
        ]
    }
}

const constructStowFloorDataRequest = (nodeId, zone) => {
    return {
        filters: {
            NODE: [nodeId],
            ZONE: zone
        },
        fieldsRequired: [
            FloorData.FLOOR_LABEL,
            FloorData.CART_DATA
        ]
    }
}

const constructStowFloorDataRequestWithRouteDetails = (nodeId, zone) => {
    return {
        filters: {
            NODE: [nodeId],
            ZONE: zone
        },
        fieldsRequired: [
            FloorData.FLOOR_LABEL,
            FloorData.CART_DATA,
            FloorData.ROUTE_CODE,
            FloorData.ROUTE_ID
        ]
    }
}

const constructStowPackageMetricsRequest = (nodeId, zone) => {
    return {
        groupBy: Resource.CART_LOCATION,
        filters: {
            NODE: [nodeId],
            CLUSTER: zone
        },
        metrics: [
            StowPackageMetric.CURRENT_INDUCTED_COUNT,
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.CURRENT_STOWED_COUNT,
            StowPackageMetric.PROBLEM_SOLVE_COUNT,
            StowPackageMetric.STOW_RATE,
            StowPackageMetric.SCAN_COMPLIANCE
        ]
    }
}



// WEBPACK FOOTER //
// ./src/actions/CartLocationActions.js